/* VIBECRAFTS Watermark Protection — v3 (Guaranteed)
   RULE: Right-click menu ORIGINAL image pe KABHI nahi khulega.
         Menu sirf watermarked cover pe khulta hai.
         => Menu khula matlab copy/save 100% watermark wala hoga.
   - Hover karte hi watermark background me ban jata hai (first right-click instant)
   - Theme ke overlay/link ke neeche wali images bhi detect hoti hain
   - Original image DOM me kabhi move nahi hoti => no blink
*/
(function () {
  'use strict';

  var WM_TEXT = 'VIBECRAFTS';

  var blobCache = {};   // src -> watermarked blob URL
  var pending   = {};   // src -> generation in progress
  var cover     = null; // single reusable overlay <img>
  var coverSrc  = '';

  /* ---------- Watermark generation (cached) ---------- */

  function generate(src, cb) {
    cb = cb || function () {};
    if (blobCache[src]) { cb(blobCache[src]); return; }
    if (pending[src])   { cb(null); return; }
    pending[src] = true;

    var temp = new Image();
    temp.crossOrigin = 'anonymous';

    temp.onload = function () {
      var w = temp.naturalWidth, h = temp.naturalHeight;
      if (!w || !h) { pending[src] = false; cb(null); return; }

      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d');

      try { ctx.drawImage(temp, 0, 0, w, h); }
      catch (e) { pending[src] = false; cb(null); return; }

      ctx.translate(w / 2, h / 2);
      ctx.rotate(-Math.atan2(h, w));
      ctx.font = 'bold ' + Math.floor(w / 7) + 'px Arial';
      ctx.fillStyle = 'rgba(128,128,128,0.45)';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(WM_TEXT, 0, 0);

      c.toBlob(function (blob) {
        pending[src] = false;
        if (!blob) { cb(null); return; }
        blobCache[src] = URL.createObjectURL(blob);
        cb(blobCache[src]);
      }, 'image/png', 0.95);
    };

    temp.onerror = function () { pending[src] = false; cb(null); };
    temp.src = src;
  }

  /* ---------- Single global cover overlay ---------- */

  function ensureCover() {
    if (cover) return cover;
    cover = document.createElement('img');
    cover.alt = '';
    cover.draggable = true;
    cover.style.cssText =
      'position:fixed;display:none;margin:0;padding:0;border:0;' +
      'opacity:0;z-index:2147483647;pointer-events:auto;';
    document.body.appendChild(cover);
    return cover;
  }

  function hideCover() {
    if (cover && cover.style.display !== 'none') {
      cover.style.display = 'none';
      coverSrc = '';
    }
  }

  function showCover(img) {
    var src = img.currentSrc || img.src;
    if (!src) return false;

    var c = ensureCover();
    var url = blobCache[src];
    if (!url) { generate(src); return false; }

    var r = img.getBoundingClientRect();
    c.src = url;
    c.style.left   = r.left + 'px';
    c.style.top    = r.top + 'px';
    c.style.width  = r.width + 'px';
    c.style.height = r.height + 'px';
    c.style.display = 'block';
    coverSrc = src;
    return true;
  }

  /* ---------- Image dhundo: overlay/link/shadow-DOM ke neeche bhi ---------- */

  function isCover(el) { return cover && el === cover; }

  function findImage(e) {
    // 1) Event ke asli path me IMG dhundo (shadow DOM cases)
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || n === document) break;
      if (n.tagName === 'IMG' && !isCover(n)) return n;
    }
    // 2) Pointer ke neeche stacked elements me IMG dhundo
    //    (theme ke invisible link/overlay ke neeche wali image)
    if (document.elementsFromPoint && typeof e.clientX === 'number') {
      var els = document.elementsFromPoint(e.clientX, e.clientY);
      for (var j = 0; j < els.length; j++) {
        if (els[j].tagName === 'IMG' && !isCover(els[j])) return els[j];
      }
    }
    return null;
  }

  /* ---------- Delegated listeners ---------- */

  // Hover pe watermark pehle se bana lo => first right-click instant
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && !isCover(t)) {
      var src = t.currentSrc || t.src;
      if (src && !blobCache[src] && !pending[src]) generate(src);
    }
  }, true);

  // Right mousedown: contextmenu se pehle hi cover position kar do
  document.addEventListener('mousedown', function (e) {
    if (e.button === 2) {
      var img = findImage(e);
      if (img) showCover(img);
      return;
    }
    if (e.button === 0 && isCover(e.target)) {
      // Cover pe left-click: hatao, neeche wale element pe click pass karo
      var x = e.clientX, y = e.clientY;
      hideCover();
      e.preventDefault();
      e.stopPropagation();
      var el = document.elementFromPoint(x, y);
      if (el) el.click();
      return;
    }
    if (e.button === 0) hideCover();
  }, true);

  // CORE RULE: menu sirf cover pe khulta hai, original pe kabhi nahi
  document.addEventListener('contextmenu', function (e) {
    if (isCover(e.target)) return;      // watermarked => menu allowed

    var img = findImage(e);
    if (!img) { hideCover(); return; }  // image nahi => normal menu

    e.preventDefault();                 // original pe menu HAMESHA block
    e.stopPropagation();
    showCover(img);                     // ready hai to cover laga do
                                        // (agla right-click cover pe padega)
  }, true);

  // Drag: original kabhi drag nahi hoga; cover drag = watermarked
  document.addEventListener('dragstart', function (e) {
    if (isCover(e.target)) return;
    var img = findImage(e);
    if (!img) return;
    e.preventDefault();
    var src = img.currentSrc || img.src;
    if (src) generate(src);
  }, true);

  // Mobile long-press
  var touchTimer = null;
  document.addEventListener('touchstart', function (e) {
    if (isCover(e.target)) return;
    var t = e.touches && e.touches[0];
    var fake = t ? { composedPath: e.composedPath ? e.composedPath.bind(e) : null,
                     clientX: t.clientX, clientY: t.clientY, target: e.target } : e;
    var img = findImage(fake);
    if (!img) { hideCover(); return; }
    var src = img.currentSrc || img.src;
    if (src) generate(src);
    touchTimer = setTimeout(function () { showCover(img); }, 300);
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', function () {
    clearTimeout(touchTimer);
    hideCover();
  }, { capture: true, passive: true });

  document.addEventListener('touchend', function () {
    clearTimeout(touchTimer);
  }, { capture: true, passive: true });

  // Scroll/resize pe cover ki position galat ho jayegi => hata do
  window.addEventListener('scroll', hideCover, { capture: true, passive: true });
  window.addEventListener('resize', hideCover, { passive: true });

})();